/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#alerts[_ngcontent-%COMP%]{position:fixed;width:100%;padding:.25rem .5rem;z-index:4}#alerts[_ngcontent-%COMP%]   clr-alert[_ngcontent-%COMP%]{max-width:20rem;margin:auto;z-index:inherit}"];
export { styles as styles };

